import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import findPwNot from "../../styles/images/img_findPw.png";
import OnePageLayout from "../../components/layout/OnePageLayout";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const FindPwResult = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const userId = location.state !== null ? location.state.userId : "";
  const result = location.state !== null ? location.state.result : "";
  const tid = location.state !== null ? location.state.tid : "";
  useEffect(() => {
    // console.log("result", result, userId);
    if (userId) {
      navigate("/resetting/password", { state: { email: userId, tid: tid } });
    }
  }, []);
  return (
    <OnlyHeaderLayout title="회원가입">
      <Section>
        <Content>
          <TextDiv>
            <h3>아직 회원이 아니시군요!</h3>
            <InfoText>
              고객님은 현재 뮤포인트 회원이 아닙니다.
              <br />
              아래 회원가입 을 눌러 회원이 되세요.
              <br />
              다양한 Alliance 회원사 포인트를
              <br />
              뮤포인트 로 빠르고 쉽게 <span>통합</span> 관리 하세요.
              <br />
            </InfoText>
          </TextDiv>
          <StyledImgWrap margintop="3" width="22.7">
            <img src={findPwNot} alt="" />
          </StyledImgWrap>
        </Content>
        <Btns>
          <ButtonL
            onClick={() => {
              navigate("/sign-up");
            }}
          >
            회원가입
          </ButtonL>
        </Btns>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default FindPwResult;

const InfoText = styled.p`
  margin-top: 2rem;
`;
const StyledImgWrap = styled(ImgWrap)`
  margin-top: ${(props) => props.margintop}rem;
  img {
    width: 22.7rem;
  }
`;
